import { render, staticRenderFns } from "./Lotacao.vue?vue&type=template&id=459be5b3&scoped=true&"
import script from "./Lotacao.vue?vue&type=script&lang=js&"
export * from "./Lotacao.vue?vue&type=script&lang=js&"
import style0 from "./Lotacao.vue?vue&type=style&index=0&id=459be5b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459be5b3",
  null
  
)

export default component.exports